import { useContextSnackbar } from '../../contexts/snackbarContext'
import { useTranslation } from 'react-i18next'
import { AnimationState } from '../../constants/animationStates'
import { cn } from '../../utils/cn'

const animationClassNames: Record<AnimationState, string> = {
  [AnimationState.UNSET]: '',
  [AnimationState.PLAY]: 'animate-[slide-up_0.3s_ease-in-out]',
  [AnimationState.PAUSE]: 'animate-[slide-out_0.3s_ease-in-out]',
}

const Snackbar = () => {
  const { snackbarText, snackbarVisibilityState } = useContextSnackbar()
  const { t } = useTranslation()

  return (
    <div
      className={cn('justify-center', {
        hidden: snackbarVisibilityState === AnimationState.UNSET,
        flex: snackbarVisibilityState !== AnimationState.UNSET,
      })}
    >
      <div
        className={cn(
          'fixed bottom-0 z-[1000] flex min-h-[38px] max-w-[58vw] items-center rounded-t-[20px] border-0 bg-black shadow-floating xs:max-w-[48vw] md:min-h-[45px] md:rounded-t-[24px] xl:min-h-[82px] xl:max-w-[45vw] xl:rounded-t-[39px] xxl:bottom-[6vh] xxl:rounded-[69px]',
          animationClassNames[snackbarVisibilityState],
        )}
      >
        <span className="px-[20px] py-[8px] text-center font-approach-medium text-[14px] leading-[initial] text-white xs:px-[24px] xs:py-[12px] sm:px-[40px] sm:py-[18px] sm:text-[18px] lg:text-[24px] xl:px-[80px] xl:py-[25px] xxl:text-[26px]">
          {t(snackbarText)}
        </span>
      </div>
    </div>
  )
}

export default Snackbar
